const parent = '';

export default parent;

export const home = `${parent}/`;
